export default [
  {
    value: `games`,
    label: `Компьютерные игры`
  },
  {
    value: `auto`,
    label: `Авто и мото`
  },
  {
    value: `travel`,
    label: `Путешествия`
  },
  {
    value: `comics`,
    label: `Комиксы`
  },
  {
    value: `movie`,
    label: `Кино и сериалы`
  },
  {
    value: `animals`,
    label: `Животные`
  },
  {
    value: `music`,
    label: `Музыка`
  },
  {
    value: `art`,
    label: `Искусство`
  }
];
